
import { Helmet } from 'react-helmet-async';
import { useFavicon } from '@/hooks/useFavicon';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  image?: string;
  url?: string;
}

export const SEO = ({ 
  title = "VRAM - Modern E-commerce Platform",
  description = "Discover amazing products with our modern e-commerce platform",
  keywords = "ecommerce, shopping, products, online store",
  image = "/placeholder.svg",
  url = window.location.href
}: SEOProps) => {
  // Initialize favicon management
  useFavicon();

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};
